/* ═══════════════════════════════════════════════════════════════════════════
   Origin Pour — Theme JavaScript
   Vanilla JS, no dependencies.
   ═══════════════════════════════════════════════════════════════════════════ */

/* ── Password reveal toggle (global, delegated) ────────────────────────
   Any [data-reveal-password] button toggles the sibling password input
   between type=password and type=text, flipping its aria-pressed so
   the CSS swaps the eye-on / eye-off icons. Delegation means future
   password fields work without JS changes. */
document.addEventListener('click', function (e) {
  var btn = e.target && e.target.closest && e.target.closest('[data-reveal-password]');
  if (!btn) return;
  var wrap = btn.closest('.customer-auth__password-wrap') || btn.parentElement;
  if (!wrap) return;
  var input = wrap.querySelector('input[type="password"], input[type="text"]');
  if (!input) return;
  var willReveal = input.type === 'password';
  input.type = willReveal ? 'text' : 'password';
  btn.setAttribute('aria-pressed', willReveal ? 'true' : 'false');
  var label = willReveal ? 'Hide password' : 'Show password';
  btn.setAttribute('aria-label', label);
  btn.setAttribute('title', label);
});

document.addEventListener('DOMContentLoaded', function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Scroll Reveal (IntersectionObserver) ─────────────────────────────
     Content starts hidden at opacity: 0 for the animation. If something goes
     wrong (observer never fires, headless capture, etc.), a safety timeout
     force-reveals everything so the page never ends up with permanently
     invisible content. */

  var revealElements = document.querySelectorAll('.reveal');

  function showAllReveal() {
    revealElements.forEach(function (el) {
      if (!el.classList.contains('is-visible')) {
        el.classList.add('is-visible');
      }
    });
  }

  if (prefersReducedMotion) {
    showAllReveal();
  } else if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseInt(el.getAttribute('data-delay'), 10) || 0;

            setTimeout(function () {
              el.classList.add('is-visible');
            }, delay);

            revealObserver.unobserve(el);
          }
        });
      },
      {
        /* Any overlap triggers reveal; rootMargin lets items animate in
           before they fully enter the viewport. */
        threshold: 0,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    revealElements.forEach(function (el) {
      revealObserver.observe(el);
    });

    /* Safety net: force-reveal anything that hasn't fired after 2.5s.
       Fixes headless screenshots and any edge-case where the observer
       fails to trigger for content that never crosses the threshold. */
    setTimeout(showAllReveal, 2500);
  } else {
    /* No observer support: show everything immediately */
    showAllReveal();
  }


  /* ── Sticky Header ─────────────────────────────────────────────────── */

  var header = document.querySelector('.header');

  if (header) {
    var scrollThreshold = 50;
    var lastScrollY = 0;
    var ticking = false;

    function updateHeader() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollY > scrollThreshold) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }

      lastScrollY = scrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }


  /* ── Mobile Menu Toggle ────────────────────────────────────────────── */

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuClose = document.querySelector('[data-menu-close]');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileOverlay = document.querySelector('.mobile-nav-overlay');

  function openMobileMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    if (mobileOverlay) mobileOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (menuClose) menuClose.focus();
  }

  function closeMobileMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (menuToggle) menuToggle.focus();
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', openMobileMenu);
  }

  if (menuClose) {
    menuClose.addEventListener('click', closeMobileMenu);
  }

  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMobileMenu);
  }

  /* Close on Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });


  /* ── Announcement Bar Dismiss ──────────────────────────────────────── */

  var announcementBar = document.querySelector('.announcement-bar');
  var announcementDismiss = document.querySelector('[data-announcement-dismiss]');
  var announcementStorageKey = 'originpour_announcement_dismissed';

  if (announcementBar) {
    /* Check if previously dismissed */
    if (localStorage.getItem(announcementStorageKey) === 'true') {
      announcementBar.style.display = 'none';
    }

    if (announcementDismiss) {
      announcementDismiss.addEventListener('click', function () {
        announcementBar.style.display = 'none';
        localStorage.setItem(announcementStorageKey, 'true');
      });
    }
  }


  /* ── Cart Count Badge Update ───────────────────────────────────────── */

  /**
   * Update the cart count badge in the header.
   * Call this after any cart AJAX operation:
   *   window.OriginPour.updateCartCount(newCount);
   */
  window.OriginPour = window.OriginPour || {};

  window.OriginPour.updateCartCount = function (count) {
    var badges = document.querySelectorAll('.header__cart-count');
    badges.forEach(function (badge) {
      badge.textContent = count > 0 ? count : '';
      badge.setAttribute('data-count', count);
    });
  };
});
